import React from 'react';
import ReportCardWorkspace from './ReportCardWorkspace';
import { CATEGORIZED_FORMATS } from './ReportCardFormatSelector';

export const MARKS_CARD_FORMATS = CATEGORIZED_FORMATS.flatMap(c => c.formats);

const ReportCards = (props) => {
  return <ReportCardWorkspace {...props} />;
};

export default ReportCards;
